function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.375 18.0312L7.1875 18.875C6.96875 19.0312 6.65625 19.0312 6.40625 18.9062C6.15625 18.7812 6 18.5312 6 18.25V16H5C3.34375 16 2 14.6562 2 13V6C2 4.34375 3.34375 3 5 3H15C16.6562 3 18 4.34375 18 6V13C18 14.6562 16.6562 16 15 16H11.25L8.375 18.0312ZM10.375 14.7812C10.625 14.5938 10.9375 14.5 11.25 14.5H15C15.8438 14.5 16.5 13.8438 16.5 13V6C16.5 5.1875 15.8438 4.5 15 4.5H5C4.1875 4.5 3.5 5.1875 3.5 6V13C3.5 13.8438 4.1875 14.5 5 14.5H6.75C7.0625 14.5 7.34375 14.7188 7.46875 15C7.5 15.0625 7.5 15.1562 7.5 15.25V16.8125C8.53125 16.0938 9.46875 15.4062 10.375 14.7812Z",
  fill: "currentColor"
});

function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.2d374ee0.svg";
export { ForwardRef as ReactComponent };